<template>
  <div class="morpheus">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'MyWallet',
  mounted () {
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="less">
.morpheus{
  height: 100vh;
  width: 100%;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/Morpheus/Morpheus.vue